<template>
  <v-data-table
    :headers="headers"
    :items="processes"
    :items-per-page-options="CONST.ROWS_PER_PAGE_ITEMS"
    :items-per-page-text="CONST.ROWS_PER_PAGE_TEXT">
    <template #[`item.date`]="{ item }">
      {{ formatLocalDate(getRawItem(item).date) }}
    </template>
    <template #[`item.status`]="{ item }">
      <v-chip :color="getStatus(getRawItem(item).status).color" size="small" variant="tonal">
        {{ getStatus(getRawItem(item).status).title }}
      </v-chip>
    </template>
    <template #[`item.summary.inputKg`]="{ item }">{{ formatKg(item.summary?.inputKg) }} kg</template>
    <template #[`item.summary.exportKg`]="{ item }">{{ formatKg(item.summary?.exportKg) }} kg</template>
    <template #[`item.summary.exportEfficiency`]="{ item }">{{ formatPercent(item.summary?.exportEfficiency) }}</template>
    <template #[`item.summary.differenceKg`]="{ item }">{{ formatKg(item.summary?.differenceKg) }} kg</template>
    <template #[`item.actions`]="{ item }">
      <div class="action-cell">
        <v-btn icon size="small" variant="text" class="table-action-button" :aria-label="actionLabel(getRawItem(item))" @click="editItem(getRawItem(item))">
          <v-icon>{{ getRawItem(item).status === PROCESS_STATUS.DRAFT ? 'edit' : 'visibility' }}</v-icon>
        </v-btn>
      </div>
    </template>
    <template v-slot:no-data>
      <span>{{ CONST.NO_RESULTS_CHECK_FILTERS }}</span>
      <v-btn color="primary" @click="initialize">{{ CONST.REFRESH }}</v-btn>
    </template>
  </v-data-table>
</template>
<script>
import CONST from '../../services/common/Constants.js'
import { formatLocalDate as formatDate } from '../../services/common/UtilsFunctions'
import { mapGetters } from 'vuex'
import { getProcessStatus, PROCESS_STATUS } from '../../services/process/ProcessStatus'
import { formatKg, formatPercent } from '../../services/process/ProcessMetrics'
export default {
  name: 'ProcessTable',
  data: () => ({
    CONST: {},
    PROCESS_STATUS,
    headers: [
      {title: 'Nro. PP', align: 'center', key: 'processNumber'},
      {title: 'Nombre', align: 'center', key: 'referenceName'},
      {title: 'Fecha', align: 'center', key: 'date', sortable: false},
      {title: 'Estado', align: 'center', key: 'status'},
      {title: 'Entrada kg', align: 'end', key: 'summary.inputKg'},
      {title: 'Exportación kg', align: 'end', key: 'summary.exportKg'},
      {title: 'Eficiencia', align: 'end', key: 'summary.exportEfficiency'},
      {title: 'Diferencia kg', align: 'end', key: 'summary.differenceKg'},
      {title: 'Observaciones', align: 'center', key: 'obs', sortable: false},
      {title: 'Acciones', align: 'center', key: 'actions', sortable: false}
    ],
    processes: []
  }),

  computed: {
    ...mapGetters(['isRefreshTableRequired']),
    ...mapGetters('processModule', ['getFilteredProcesses'])
  },

  created () {
    this.CONST = CONST
    this.initialize()
  },

  watch: {
    'getFilteredProcesses': function () {
      this.processes = this.$store.getters['processModule/getFilteredProcesses']
    },
    'isRefreshTableRequired': function (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.initialize()
      }
    }
  },

  methods: {
    formatKg,
    formatPercent,
    initialize () {
      this.$store.dispatch('processModule/getProcesses').then(() => {
        let items = this.$store.getters['processModule/getProcesses']
        this.processes = (!items) ? Object.assign([], []) : items
      })
    },

    formatLocalDate (value) {
      return formatDate(value)
    },

    getRawItem (item) {
      return item.raw || item
    },

    getStatus (status) {
      return getProcessStatus(status)
    },

    actionLabel (item) {
      return item.status === PROCESS_STATUS.DRAFT ? 'Editar' : 'Ver detalle'
    },

    async editItem (item) {
      try {
        await this.$store.dispatch('processModule/getProcessById', item.id)
        this.$store.dispatch('processModule/setDialogActived', true)
      } catch (error) {
        let errorMsg = 'No se pudo abrir el parte de proceso seleccionado. Intente actualizar la tabla y vuelva a abrirlo.'
        let data = { infoDialog: true, title: 'ERROR', content: errorMsg, closeBtnLabel: 'Entendido' }
        this.$store.dispatch('alertDialogModule/setData', data)
      }
    }
  }
}
</script>
